// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Si5D","title":"Images45_title__1wG6K","images":"Images45_images__3o-_Y"};